var BB = function() {
	new app.blazy();
}();
